<div *ngFor="let question of getQuestions()">
    <app-generic-display [Question]="question" [SurveyBase]="SurveyBase">
    </app-generic-display>
</div>


<lib-btn-save [currentSurvey]="SurveyBase" (saveEventEmitter)="save($event)"></lib-btn-save>
